import { makeObservable, observable, action } from 'mobx';
import { ICallRow } from '../../../swagger/external';

class CallsStore {
  listData: ICallRow[] = [];

  constructor() {
    makeObservable(this, {
      listData: observable,
      setListData: action
    });
  }

  setListData(rows: ICallRow[]) {
    this.listData = rows;
  }
}

const callsStore = new CallsStore();
export default callsStore;
